// frozen_string_literal: true

export class MapUpdater {
  updateMap(vehicles, counts, timestamp) {
    // Tentar comunicar com o controller do mapa diretamente
    const mapElement = document.querySelector('[data-controller*="monitoring-map"]')
    
    if (mapElement && mapElement.monitoringMapController) {
      mapElement.monitoringMapController.updateVehicleData(vehicles)
    } else {
      // Fallback: disparar evento customizado
      document.dispatchEvent(new CustomEvent('vehicles:updated', {
        detail: { 
          vehicles: vehicles,
          counts: counts,
          timestamp: timestamp
        }
      }))
    }
  }
}